import { createUseStyles } from 'react-jss'

export default createUseStyles({
  searchOrganizations: {
    marginBottom: 30
  }
})